import { MotionProvider } from "@/motion";
import { AuroraBackground } from "@/components/ui/aurora-background";
import { VelarisBackground, type VelarisPalette } from "@/components/VelarisBackground";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { ProductRange } from "@/sections/ProductRange";
import { BrandIntro } from "@/sections/BrandIntro";
import { SymbolStory } from "@/sections/SymbolStory";
import { CallToAction } from "@/sections/CallToAction";

// Chosen at build time so the unused background is tree-shaken out of the bundle.
const BG = import.meta.env.VITE_BG ?? "aurora";
const PALETTE = (import.meta.env.VITE_PALETTE ?? "sage") as VelarisPalette;

export default function App() {
  const page = (
    <>
      <Nav />
      <main className="page__content">
        <Hero />
        <ProductRange />
        <BrandIntro />
        <SymbolStory />
        <CallToAction />
      </main>
      <Footer />
    </>
  );

  if (BG === "velaris") {
    return (
      <MotionProvider>
        <VelarisBackground palette={PALETTE} className="page">
          {page}
        </VelarisBackground>
      </MotionProvider>
    );
  }

  return (
    <MotionProvider>
      <AuroraBackground fixed className="page">
        {page}
      </AuroraBackground>
    </MotionProvider>
  );
}
